(() => {
  const controllers = new Map();
  const initialize = (root = document) => {
    root.querySelectorAll('[data-mint-header]').forEach((header) => {
      if (controllers.has(header)) return;
      const button = header.querySelector('[data-mint-menu]');
      const nav = header.querySelector('.dg-nav');
      if (!button || !nav) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      controllers.set(header, controller);
      const media = window.matchMedia('(max-width: 1199px)');
      const closeDetails = () => nav.querySelectorAll('details[open]').forEach((item) => item.removeAttribute('open'));
      const setOpen = (open, returnFocus = false) => {
        const expanded = media.matches && open;
        button.setAttribute('aria-expanded', String(expanded));
        header.dataset.menuOpen = String(expanded);
        nav.hidden = media.matches && !expanded;
        if (!expanded) closeDetails();
        if (returnFocus) button.focus();
      };
      button.hidden = false;
      setOpen(false);
      button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'), options);
      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeDetails();
        if (button.getAttribute('aria-expanded') === 'true') {
          event.preventDefault();
          setOpen(false, true);
        }
      }, options);
      nav.addEventListener('click', (event) => {
        if (event.target.closest('a') && media.matches) setOpen(false);
      }, options);
      document.addEventListener('click', (event) => {
        if (header.contains(event.target)) return;
        closeDetails();
        if (button.getAttribute('aria-expanded') === 'true') setOpen(false);
      }, options);
      media.addEventListener('change', () => setOpen(false), options);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [header, controller] of controllers) {
      if (event.target.contains(header)) {
        controller.abort();
        controllers.delete(header);
      }
    }
  });
})();
